import { render } from "./404.vue?vue&type=template&id=57444a4e&scoped=true"
const script = {}

import "./404.css?vue&type=style&index=0&id=57444a4e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57444a4e"]])

export default __exports__